// @ts-nocheck
import { Cart } from "@insite/client-framework/Services/CartService";
import { hasRestrictedCartLines, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { productHasPrice } from "@store/Framework/Store/Data/Products/ProductsSelectors";

export const hasProductsWithInvalidPrice = (cart: Cart | undefined) => {
    return cart?.cartLines?.some(
        cartLine =>
            !cartLine.isPromotionItem &&
            !cartLine.quoteRequired &&
            !cartLine.allowZeroPricing &&
            cartLine.pricing?.unitNetPrice === 0 &&
            cartLine.pricing?.unitRegularPrice === 0 &&
            // Foundation
            !productHasPrice(cartLine),
    );
};
// Store Custom Code - prevent add to cart
const isAddToCartPrevented = (cart: Cart | undefined) => {
    return cart?.cartLines?.every(cartLine => !cartLine.availability?.preventAddToCart);
};

export const isCartCheckoutDisabled = (cart: Cart | undefined) =>
    cart &&
    ((!cart.canCheckOut && !cart.canRequisition) ||
        isCartEmpty(cart) ||
        hasRestrictedCartLines(cart) ||
        hasProductsWithInvalidPrice(cart) ||
        // Store Custom Code - prevent add to cart
        !isAddToCartPrevented(cart));
